/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { RowPath } from "./RowPath";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var CellPath = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(CellPath, _super);
    function CellPath(a) {
        var _rest = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            _rest[_i - 1] = arguments[_i];
        }
        var _this = this;
        a = (a == void 0) ? 0 : a;
        switch (a) {
            case 0:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    var e = _rest[2];
                    var f = _rest[3];
                    var g = [d, e, f];
                    {
                        var i = g[0];
                        var j = g[1];
                        var k = g[2];
                        _this = _super.call(this, j, k) || this;
                        _this.av = 0;
                        _this.aw = 0;
                        _this.au = -1;
                        _this.ap = false;
                        _this.ae = false;
                        _this.ad = false;
                        _this.am = false;
                        _this.af = false;
                        _this.av = i;
                        _this.ac();
                    }
                    _this.b = c;
                    _this.ac();
                }
                break;
            case 1:
                {
                    var c = _rest[0];
                    var d = _rest[1];
                    var e = _rest[2];
                    _this = _super.call(this, d, e) || this;
                    _this.av = 0;
                    _this.aw = 0;
                    _this.au = -1;
                    _this.ap = false;
                    _this.ae = false;
                    _this.ad = false;
                    _this.am = false;
                    _this.af = false;
                    _this.av = c;
                    _this.ac();
                }
                break;
        }
        return _this;
    }
    Object.defineProperty(CellPath.prototype, "ax", {
        get: function () {
            return this.av;
        },
        set: function (a) {
            this.av = a;
            this.ac();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "a2", {
        get: function () {
            return this.aw;
        },
        set: function (a) {
            this.aw = a;
        },
        enumerable: true,
        configurable: true
    });
    CellPath.prototype.ac = function () {
        _super.prototype.ac.call(this);
        this.au = (this.ax * 100000000) + _super.prototype.getHashCode.call(this);
    };
    CellPath.prototype.getHashCode = function () {
        return this.au;
    };
    CellPath.prototype.equals = function (a) {
        if (!_super.prototype.equals.call(this, a)) {
            return false;
        }
        var b = a;
        if (a == null) {
            return false;
        }
        if (this.av != b.av) {
            return false;
        }
        if (this.ar != b.ar) {
            return false;
        }
        if (this.ao != b.ao) {
            return false;
        }
        return true;
    };
    CellPath.prototype.toString = function () {
        return this.av + "." + _super.prototype.toString.call(this);
    };
    CellPath.prototype.aa = function () {
        var a = new CellPath(0, this.b, this.av, this.x, this.w);
        a.a2 = this.a2;
        a.ar = this.ar;
        a.ao = this.ao;
        a.i = this.i;
        a.o = this.o;
        a.d = this.d;
        a.am = this.am;
        a.af = this.af;
        a.ap = this.ap;
        return a;
    };
    Object.defineProperty(CellPath.prototype, "aq", {
        get: function () {
            return (this.av == -300);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "ag", {
        get: function () {
            return ((this.av >= 0 || this.av == -800 || this.av == -400) && this.w >= 0 && this.w >= 0);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "as", {
        get: function () {
            return this.av == -400 || this.av == -401 || this.av == -402;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "ah", {
        get: function () {
            return this.g && !this.aq;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "an", {
        get: function () {
            return this.w == -102 && this.av == -400;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "aj", {
        get: function () {
            return (this.w == -103 || this.w == -104) && this.ax == -500;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "al", {
        get: function () {
            return (this.w == -103 || this.w == -104) && this.ax == -501;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "ai", {
        get: function () {
            return this.w == -100 && this.ax == -500;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "ak", {
        get: function () {
            return this.w == -100 && this.ax == -501;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "ar", {
        get: function () {
            return this.ae;
        },
        set: function (a) {
            this.ae = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "ao", {
        get: function () {
            return this.ad;
        },
        set: function (a) {
            this.ad = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(CellPath.prototype, "at", {
        get: function () {
            return this.ar || this.ao;
        },
        enumerable: true,
        configurable: true
    });
    CellPath.$t = markType(CellPath, 'CellPath', RowPath.$);
    return CellPath;
}(RowPath));
export { CellPath };
//# sourceMappingURL=CellPath.js.map
